import { render, staticRenderFns } from "./Tenants.vue?vue&type=template&id=532d82e8&scoped=true&"
import script from "./Tenants.vue?vue&type=script&lang=js&"
export * from "./Tenants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532d82e8",
  null
  
)

export default component.exports